export default {
  goods: {
    search: {
      startDate: '开始时间',
      endDate: '结束时间',
      productChName: '中文名称',
      parentProductStatus: '数据状态',
      groupCategory: '集团产品分类',
      detailProductDisplayName: '显示名称',
      productDetailCode: '商品详细编码',
      detailProductSearchCode: '搜索简码',
      detailProductInvoiceName: '开票名称',
    },
    table: {
      pleaseChange: '请选择',
      index: '序号',
      productDetailCode: '商品详细编码',
      detailProductDisplayName: '显示名称',
      detailProductSearchCode: '搜索简码',
      detailProductInvoiceName: '开票名称',
      detailProductStatus: '当前状态',
      gmtCreate: '生成时间',
      parentProductNo: '商品编码',
      productChName: '中文名称',
      productEnName: '英文名称',
      departmentName: '部门',
      requestPerson: '申请人',
      groupCategory: '集团产品分类',
      parentProductStatusName: '当前状态',
      overShippedPercentage: '溢装比例(%)',
      shortShippedPercentage: '短装比例(%)',

      detailProductOriginalPlace: '产地',
      detailProductModel: '规格型号',
      detailProductLevel: '等级',
      detailProductOther: '其他',
      detailProductStatusName: '数据状态',
      personCompanyName: '公司',
      personDepartmentName: '部门',
      isUsed: '是否启用',

      incomeCourse: '收入科目',
      purchaseOrderUnit: '采购订单单位',
      salesOrderUnit: '销售订单单位',
      costCourse: '成本科目',

      time: '时间',
      updateContent: '变更信息',
    },
    mappingData: {
      onedataType: '中台类别',
      onedataTypeValue: '中台类别值',
      mapSystemName: '映射系统',
      mapType: '映射类别',
      mapTypeValue: '映射类别值',
      status: '状态',
      gmtCreate: '操作时间',
      seq: '序号',
      success: '成功',
      error: '失败',
    },
    message: {
      createBy: '请选择创建人',
      productChName: '请输入商品名称',
      productSearchCode: '请输入搜索简码',
      productEnName: '请输入英文名称',
      detailProductModel: '请输入规格型号',
      detailProductLevel: '请输入等级',
      overShippedPercentage: '请输入溢装比例',
      shortShippedPercentage: '请输入短装比例',
      detailProductInvoiceName: '请输入开票名称',
      groupCategory: '请选择商品分类',
      basicUnit: '请选择基本单位',
      vartRate: '请选择增值税率',
      customsId: '请选择海关编码',
      detailProductOriginalPlace: '请输入产地',
      extendCompanyCode: '请选择',
      all: '所有',
      yes: '是',
      no: '否',
      noChooseDel: '您还没选择想要删除的数据',
      noChooseCopy: '您还没选择想要复制的行数据',
      cannotDeleteDataDetails: '不能删除有商品详细编码的行数据',
      delSuccess: '删除成功',
      unDel: '取消删除',
      duplicateItem: '您有一条重复的商品明细',
      currentUsersCannotAdd: '当前用户不可新增公司信息',
      productDetailsRepeated: '商品中文名称或者商品明细显示名称重复',
      onlyActiveDisabledDisabled: '只能禁用已生效状态的数据,请重新选择',
      onlyDisabledUnblocked: '只有禁用状态的数据才能进行解禁用操作,请重新选择',
      forciblyDisable: '强制禁用',
      importError: '只有审批中状态的数据可进行此操作',
      messageInfoCustoms: '已删除产品信息中没有海关信息的商品',
      incomeTaxRate: '请选择进项税码',
      sellTaxRate: '请选择销项税码',
    },
    button: {
      add: '创建商品主数据',
      addChildren: '创建商品详细主数据',
      modify: '修改/显示',
      import: '导入',
      export: '导出',
      forbid: '禁用',
      forbidChild: '禁用（子类）',
      solveForbidChild: '启用(子类)',
      solveForbidParent: '启用（父类）',
      deletChange: '删除选中',
      save: '保存',
      submit: '提交',
      sureSave: '提交',
      delete: '删除',
      addRow: '新增',
      deleteRow: '删除行',
      merge: '合并',
      solveForbid: '解禁用',
      abandon: '放弃',
      copy: '复制新建',
      forbidAll: '禁用全部（子类）',
      mdg: '同步mdg',
    },
    title: {
      addGoods: '商品主数据新建',
      goodsDetail: '商品主数据详情',
      editGoods: '商品主数据修改',
      goods: '商品主数据',
      addDetailGoods: '新增商品详细主数据',
      forbidenGoods: '商品主数据禁用',
    },
    tip: {
      noneChoose: '您还未选择任何数据',
      placeChooseOne: '请选择一条数据操作',
    },
    tab: {
      wchgData: '主数据',
      companyData: '公司自有数据',
      mappingData: '系统映射表',
      historyData: '历史记录',
    },
    form: {
      basicInfo: '基本信息',
      companyName: '公司',
      departmentName: '部门',
      requestPerson: '申请人',
      requestDate: '申请时间',
      parentProductNo: '商品编码',
      productChName: '中文名称',
      productSearchCode: '搜索简码',
      productEnName: '英文名称',
      groupCategory: '集团产品分类',
      basicUnit: '基本单位',
      valueAddedTaxRate: '增值税率',
      incomeTaxRate: '进项税码',
      sellTaxRate: '销项税码',

      customerInfo: '海关信息',
      customsId: '海关编码',
      customsName: '海关名称',
      productZhName: '海关商品中文名',
      measureUnit1: '第一计量单位',
      measureUnit2: '第二计量单位',
      exportTaxRate: '退税率',
      importMfnTariffRate: '进口最惠国关税率',
      importNormalTariffRate: '进口普通关税率',
      consumptionTaxRate: '消费税税率',

      basicDetailInfo: '基本详细信息',
      dataPermision: '数据使用权限',
    },
    validate: {},
  },
};
